module.exports = __webpack_public_path__ + "assets/img/block-right-hover-5c5363c2.png";